import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import useSubmitOperation, {
    getMutationFunction,
    handleFormSubmission,
    usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";

import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";


import { Confirm } from "../../Confirmation/Confirm";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { PrintLayout_Conig } from "./PrintLayout.config";

const create_PrintLayout = gql`mutation CreatePrint_Layout($createInput: Print_LayoutInput!) {
  createPrint_Layout(createInput: $createInput) {
    _id
    Unique_Id
    tableKey
    licenseeId
    licenseeNo
    companyName
    layoutName
    branchName
    Search_Value
    Company_Code
    Branch_Code
    createdAt
    updatedAt
  }
}`;

const GetById = gql`
query Print_LayoutByID($id: ID!) {
  Print_LayoutByID(id: $id) {
    _id
     layoutName
    description
    tableKeyData {
      Table_Name
      Key
      Search_Value
      _id
    }
    licenseeIdData {
      _id
      Unique_Id
      Name
      Search_Value
    }
    Company_Code_Data {
      _id
      Name
      Search_Value
      Company_Code
      Unique_Id
    }
    Branch_Code_Data {
      _id
      Name
      Branch_Code
      Search_Value
    }
  }
}`;
const EDit_Layout = gql`
mutation EditPrint_Layout($id: ID!, $userInput: Print_LayoutInput!) {
  editPrint_Layout(id: $id, userInput: $userInput) {
    _id
    tableKey
    licenseeId
    licenseeNo
  }
}`;
const Delete_Layout = gql`
mutation DeletePrint_Layout($idsToDelete: [ID]!) {
  deletePrint_Layout(idsToDelete: $idsToDelete) {
    message
  }
}`

const AddPrintLayout = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
    const Form_Key = "PrintLayout";
    const formRef = useRef({});
    const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);


    const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
    const fielddata = fielddataRedux?.PrintLayout?.Selected_Row;
    const [toggle, settoggle] = useState(show);
    const [selectedRows, setSelectedRows] = useState([]);
    const [allFieldsData, setAllFieldsData] = useState({});
    const [FormData, setFormdata] = useState({});
    const [formErrors, setFormErrors] = useState({});


    const [CreatingData, { loading: CreatePageMaster }] = useMutation(create_PrintLayout);

    const [getPageDataById] = useLazyQuery(GetById, {
        fetchPolicy: "network-only",

    });

    const [EditingData, { loading: EditPageMaster }] = useMutation(EDit_Layout);

    const [DeletingData, { loading: DeletePageMaster }] = useMutation(Delete_Layout);

    const dispatch = useDispatch();

    const PageMasterLoadingState = CreatePageMaster || EditPageMaster || DeletePageMaster

    const HanldeChangeonForm = (values) => {
        setFormdata((prev) => ({
            ...prev,
            ...values,
        }));
    };

    const handleErrorsChange = (newErrors) => {
        setFormErrors((currentErrors) => ({
            ...currentErrors,
            ...newErrors,
        }));
    };

    const Validate_handleSubmit = (submit) => {
        const Error = checkFormErrors(formErrors);
        if (!Error) {
            submit();
        }
    };
    useEffect(() => {
        if (!TypeOfPortal.includes("Add")) {
            getPageDataById({
                variables: {
                    id: fielddata._id
                }
            }).then((res) => {
                let data = res?.data?.Print_LayoutByID;
                const Formdata = {
                    tableKey: data?.tableKeyData?.Table_Name,
                    licenseeId: data?.licenseeIdData?.Name,
                    layoutName: data?.layoutName,
                    Company_Code: data?.Company_Code_Data?.Company_Code,
                    description: data?.description,
                    Branch_Code: data?.Branch_Code_Data?.Name
                }
              
                dispatch({
                    type: "StoreMasterData",
                    payload: {
                        formkey: Form_Key,
                        data: {
                            tableKey: data?.tableKeyData,
                            licenseeId: data?.licenseeIdData,
                            Company_Code: data?.Company_Code_Data,
                            Branch_Code: data?.Branch_Code_Data
                        },
                    },
                });
                setAllFieldsData(res?.data?.Print_LayoutByID)
                updateValueForm(formRef, Formdata);
            })
        }
    }, [fielddata?._id])

    useEffect(() => {
        setSelectedRows(fielddataRedux?.PrintLayout?.Selected_Rows);
    }, [fielddataRedux]);

    const { executeOperation } = useSubmitOperation();
    const operationType = TypeOfPortal;
    let formData = FormData;


    const variables = usePrepareGraphQLVariables(operationType, allFieldsData, FormData, selectedRows);

    const MutationFunctions = {
        CreatingData,
        EditingData,
        DeletingData,
    };
    const submit = async (closeAction) => {
        FormData.tableKey = FormDataFromRedux?.MasterData[Form_Key]?.tableKey?._id;
        FormData.licenseeId = FormDataFromRedux?.MasterData[Form_Key]?.licenseeId?._id;
        FormData.Company_Code = FormDataFromRedux?.MasterData[Form_Key]?.Company_Code?._id;
        FormData.Branch_Code = FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code?._id;

        const mutationFunction = getMutationFunction(operationType, MutationFunctions);
        const executeOperationFunction = () =>
            executeOperation({
                operationType,
                data: FormData,
                selectedRows,
                Mutation: () => mutationFunction({ variables }),
                processDataBeforeSubmit: (data) => data,
                PageName: Form_Key,
                OnSuccess: () => {
                    handleFormReset(formRef);
                },
            });
        handleFormSubmission(executeOperationFunction, {
            dispatch,
            Form_Key,
            operationType,
            closeAction,
            closeFormFunction: Closeformfunction,
            resetFormDataFunction: () => {
                setAllFieldsData();
                handleFormReset(formRef);
            },
            onSuccess: () => { },
            onError: (error) => {
                ErrorToast(error.message);
            },
        });
    };

    const Closeformfunction = useCallback(() => {
        ParentPortalCloseFunction();
        settoggle(false);
        setAllFieldsData({});
        ClearSpecificForm(dispatch, Form_Key);
    });

    const SaveAndCloseForAdd = () => {
        submit("Close");
    };

    if (TypeOfPortal === "Delete") {
        return <Confirm submit={submit} settoggle={settoggle} toggle={toggle} loadingState={PageMasterLoadingState} />;
    }

    const footerContent = (
        <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={() => {
                Validate_handleSubmit(submit);
            }}
            submitType={submitType}
            SaveAndClose={
                TypeOfPortal === "Add"
                    ? () => {
                        Validate_handleSubmit(SaveAndCloseForAdd);
                    }
                    : () => {
                        Validate_handleSubmit(submit);
                    }
            }
            handleformclose={() => {
                Closeformfunction();
                settoggle(!toggle);
            }}
            loadingState={PageMasterLoadingState}
        />
    );

    return (
        <div>
            <Reactportal
                FoooterContent={footerContent}
                open={toggle}
                onClose={Closeformfunction}
                TypeOfPortal={TypeOfPortal + " Print Layout"}
                id={""}
            >
                <div className="formContainer">
                    <div>
                        {PrintLayout_Conig && PrintLayout_Conig.length > 0 ? (
                            PrintLayout_Conig.map((e, i) => (
                                <div key={e.id || i} className="FormSectionParent">
                                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                                    <div className="FormSection insidecontainer">
                                        <FormInputSectionComponent
                                            inputfields={e.fields}
                                            Type={e.name}
                                            onErrorsChange={handleErrorsChange}
                                            onhandleFormikChange={HanldeChangeonForm}
                                            formkey={Form_Key}
                                            formRef={formRef}
                                        />
                                    </div>
                                </div>
                            ))
                        ) : null}
                    </div>
                </div>
            </Reactportal>
        </div>
    );
};

export default memo(AddPrintLayout);
